import { createComponent } from 'react-fela'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'

const NavBarLabel = createComponent(
  (state) => ({
    height: '100%',
    padding: `0 ${pxTo(20, ds.get('type.baseFontSize'), 'rem')}`,
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
  }),
  'span',
)

export default NavBarLabel
